import React, { useState } from 'react';
import { MessageCircleIcon, MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const whatsappLink = 'https://wa.me/12817980349';
  return <nav className="fixed top-0 left-0 right-0 z-40 bg-black/80 backdrop-blur-md border-b border-gold/20" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="flex justify-between items-center h-20" data-id="element-64">
          {/* Logo & Brand */}
          <div className="flex items-center gap-3" data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/tytkshGoctiAv8HZxiVooC/nano-banana-2_Ultra-realistic_extreme_close-up_of_a_luxury_emblem._The_design_from_the_referen-0.jpg" alt="Killshot Digital Venture Logo" className="h-12 w-12 object-cover rounded-full border border-gold/30" data-id="element-66" />
            <span className="font-serif text-gold tracking-widest text-sm md:text-base font-semibold uppercase hidden sm:block" data-id="element-67">
              Killshot Digital Venture
            </span>
            <span className="font-serif text-gold tracking-widest text-sm font-semibold uppercase sm:hidden" data-id="element-68">
              Killshot
            </span>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-69">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-r from-gold to-gold-dark text-black px-6 py-2.5 rounded-sm font-sans font-semibold hover:opacity-90 transition-opacity hover-gold-glow" data-id="element-70">
              <MessageCircleIcon className="w-5 h-5" data-id="element-71" />
              <span data-id="element-72">Hablemos por WhatsApp</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-73">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gold p-2" aria-label="Toggle menu" data-id="element-74">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-75" /> : <MenuIcon className="w-6 h-6" data-id="element-76" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-dark-900 border-b border-gold/20 px-4 py-6" data-id="element-77">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-r from-gold to-gold-dark text-black px-6 py-3 rounded-sm font-sans font-semibold w-full" data-id="element-78">
            <MessageCircleIcon className="w-5 h-5" data-id="element-79" />
            <span data-id="element-80">Hablemos por WhatsApp</span>
          </a>
        </div>}
    </nav>;
}